module.exports = __webpack_public_path__ + "static/img/music-wave.82a5114.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/music-wave.gif
// module id = 1562
// module chunks = 180